// app/javascript/controllers/flash_message_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autoDismiss: Number }

  connect() {
    // Auto-dismiss after specified time (default 5 seconds)
    const autoDismissTime = this.hasAutoDismissValue ? this.autoDismissValue : 5000
    
    if (autoDismissTime > 0) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, autoDismissTime)
    }

    // Add initial slide-in animation from right
    this.element.style.transform = 'translateX(100%)'
    this.element.style.opacity = '0'
    
    // Trigger animation after a brief delay
    setTimeout(() => {
      this.element.style.transition = 'all 0.4s ease-out'
      this.element.style.transform = 'translateX(0)'
      this.element.style.opacity = '1'
    }, 100)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Clear timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Animate out to the right
    this.element.style.transition = 'all 0.3s ease-in'
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateX(100%)'
    
    // Remove element after animation
    setTimeout(() => {
      if (this.element && this.element.parentNode) {
        this.element.remove()
      }
    }, 300)
  }
}